import React, { useState, useEffect } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { Links } from './Links';
import './seo-links.scss';

export const LinkSets = ({ sets }) => {

  return (
    <div className="seo-links-sets">
      {sets.map((set, i) => {
        const setsClassNames = classNames(' seo-links-sets__set', {
          'seo-links-sets__set--no-break': set.links.length < 8
        });
        return (
          <div className={setsClassNames} key={`set_${set.category}_${i}`}>
            <h4 className="seo-links-sets__category">{set.category}</h4>
            <Links links={set.links || []} />
          </div>
        );
      })}
    </div>
  );
};

LinkSets.propTypes = {
  sets: arrayOf(shape({
    category: string,
    links: arrayOf(shape({
      url: string,
      keyword: string
    })),
  })).isRequired
};